import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
// import Image from "next/image";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MatchInfo = ({
  matchData = null,
  recentMatchData = null,
  scrolled = false,
}) => {

  return matchData ? (
    <div className="w-full">
      <h2 className="text-lg font-semibold">Match Details</h2>

      {/* general info card  */}
      <div className="rounded-lg border border-gray-300 flex flex-col items-start text-sm mb-8">
        <div className="w-full flex flex-col border-b p-3">
          <span className="mb-2 text-gray-500">League</span>
          <span className="">{matchData.league_name}</span>
        </div>
        <div className="w-full flex items-center gap-2 p-3 border-b">
          <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/calendar2.svg" className="w-4 h-4" />
          {matchData?.match_date_alt + ", " + matchData?.match_time}
        </div>
        {matchData?.tossstatus && (
          <div className="w-full flex items-center gap-2 p-3 border-b">
            <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/toss.svg" className="w-4 h-4" />
            {matchData?.tossstatus}
          </div>
        )}
        <div className="w-full flex items-center gap-2 p-3">
          <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/location.svg" className="w-4 h-4" />
          {matchData?.venue}
        </div>
      </div>
      {scrolled && (
        <div className="my-3">
          <AdSlot300x250
            divId={"div-gpt-ad-1659434785315-0"}
            minWidth="300px"
            minHeight="250px"
          />

          <AdSlot728x90
            divId={"div-gpt-ad-1707804176041-3"}
            minWidth="720px"
            minHeight="90px"
          />
        </div>
      )}
      {/* teams  */}
      <h2 className="text-lg font-semibold">Squads</h2>
      <div className="flex items-start justify-start gap-3 mt-2 mb-8">
        <div className="p-3 w-24 flex flex-col items-center rounded-lg border gap-2 border-gray-300">
          <img
            src={
              matchData?.altLogoA ||
              `https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamA_name}1.png`
            }
            alt="teamA_logo"
            width={52}
            height={52}
            className="mx-auto"
          />
          <span className="text-sm text-center break-words whitespace-nowrap">
            {matchData?.teamA_name == "uae" ? "UAE" : matchData?.teamA_fullname?.split(",")[0]}
          </span>
        </div>

        <div className="p-3 w-24 flex flex-col items-center rounded-lg border gap-2 border-gray-300">
          <img
            src={
              matchData?.altLogoB ||
              `https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamB_name}1.png`
            }
            alt="teamB_logo"
            width={52}
            height={52}
            className="mx-auto"
          />
          <span className="text-sm text-center whitespace-nowrap break-words ">
            {matchData?.teamB_name == "uae" ? "UAE" : matchData?.teamB_fullname?.split(",")[0]}
          </span>
        </div>
      </div>

      {/* team form data  */}
      <h2 className="text-lg font-semibold">Team Form</h2>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 py-2">
        <div className="rounded-lg p-2 flex items-center justify-between gap-2 border border-gray-300">
          <div className="flex items-center gap-1">
            <img
              width={30}
              height={30}
              src={
                matchData?.altLogoA ||
                ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamA_name}1.png`
              }
              alt="teamA logo"
              className="  mx-1"
            />
            {matchData?.teamA_name.toUpperCase()}
          </div>

          <div className="flex items-center gap-2 p-1">
            {recentMatchData?.teamA?.map((item, index) => {
              return (
                <span
                  key={index}
                  className={`p-1 w-8 text-center rounded-full text-white text-md ${item == "W"
                    ? "bg-green-500"
                    : item == "L"
                      ? "bg-primary"
                      : "bg-yellow-500"
                    }`}
                >
                  {item}
                </span>
              );
            })}
          </div>
        </div>
        <div className="rounded-lg p-2 flex items-center justify-between gap-2 border border-gray-300">
          <div className="flex items-center gap-1">
            <img
              width={30}
              height={30}
              src={
                matchData?.altLogoB ||
                ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamB_name}1.png`
              }
              alt="teamA logo"
              className="  mx-1"
            />
            {matchData?.teamB_name.toUpperCase()}
          </div>
          <div className="flex items-center gap-2 p-1">
            {recentMatchData?.teamB?.map((item, index) => {
              return (
                <span
                  key={index}
                  className={`p-1 w-8 text-center rounded-full text-white text-md ${item == "W"
                    ? "bg-green-500"
                    : item == "L"
                      ? "bg-primary"
                      : "bg-yellow-500"
                    }`}
                >
                  {item}
                </span>
              );
            })}
          </div>
        </div>
      </div>
      {/* head 2 head */}
      {matchData?.matches_h2h?.length && (
        <div className="w-full my-4">
          <h2 className="text-lg font-semibold">
            {"Head To Head"}
            <span className="text-gray-500 font-extralight">
              {" (Last " + matchData?.matches_h2h?.length + " matches)"}
            </span>
          </h2>
          <div className="flex items-center justify-center gap-4 w-full bg-[#F1F2F6] p-4 rounded-lg my-4 text-sm">
            <img
              width={50}
              height={50}
              src={
                matchData?.altLogoA ||
                ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamA_name}1.png`
              }
              alt="teamA logo"
              className="w-[40px] md:w-[50px]   ml-1"
            />
            <span>{matchData?.teamA_name.toUpperCase()}</span>
            <span className="mx-4 md:mx-8 text-2xl font-semibold">
              {matchData?.teamA_wins_h2h + " - " + matchData?.teamB_wins_h2h}
            </span>
            <span>{matchData?.teamB_name.toUpperCase()}</span>
            <img
              width={50}
              height={50}
              src={
                matchData?.altLogoB ||
                ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamB_name}1.png`
              }
              alt="teamA logo"
              className="w-[40px] md:w-[50px]   ml-1"
            />
          </div>
          <div className="w-full grid grid-cols-1 md:grid-cols-2">
            {matchData?.matches_h2h?.map((match, index) => {
              return (
                <div
                  key={index}
                  className="m-1 border border-gray-300 rounded-lg text-sm"
                >
                  <div className="text-gray-500 w-full p-2 border-b border-gray-300">
                    {match?.league_name}
                  </div>
                  <div className="flex items-center justify-between p-3 mt-2">
                    <div className="flex flex-col items-start gap-2">
                      <div className="flex items-center gap-2">
                        <img
                          width={30}
                          height={30}
                          src={
                            matchData?.altLogoA ||
                            ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamA_name}1.png`
                          }
                          alt="teamA logo"
                          className="  ml-1"
                        />
                        <span className="text-md font-semibold">
                          {matchData?.teamA_name.toUpperCase()}
                        </span>
                        {match.teamA_score}
                      </div>
                      <div className="flex items-center gap-2">
                        <img
                          width={30}
                          height={30}
                          src={
                            matchData?.altLogoB ||
                            ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.teamB_name}1.png`
                          }
                          alt="teamA logo"
                          className="  ml-1"
                        />
                        <span className="text-md font-semibold">
                          {matchData?.teamB_name.toUpperCase()}
                        </span>
                        {match.teamB_score}
                      </div>
                    </div>
                    <div className="w-[30%] pl-4 border-l border-gray-300 text-center">
                      {match.result}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* umpires  */}
      {matchData?.umpires && (
        <>
          <h2 className="text-lg font-semibold">Umpires</h2>
          <div className="w-full rounded-lg border border-gray-300 text-sm my-2">
            <div className="w-full flex flex-col gap-2 border-b border-gray-300 py-2 px-4">
              <span className="text-gray-500">Umpires</span>
              <span>{matchData?.umpires}</span>
            </div>
            <div className="w-full flex flex-col gap-2 py-2 px-4">
              <span className="text-gray-500">Referee</span>
              <span>{matchData?.referee}</span>
            </div>
          </div>
        </>
      )}
    </div>
  ) : (
    <div className="w-full text-center text-lg text-gray-500 my-16">
      No Match Data
    </div>
  );
};

export default MatchInfo;
